<template>
  <!-- v-if prevents errors when switching routes -->
  <!-- a year with a sidebar: below the width for its column, one column (Seán, 2026-10-22) -->
  <ReplaceTweets v-if="$route.name" :is-single-column="isSingleColumn">
    <!-- a year with a sidebar (sidebar.json; 2026): on a narrow screen its control takes the
         title's place, and a panel the page's (the page kept, hidden: its video plays on) -->
    <YearSidebar
      v-if="sidebar && isNarrow"
      :content="sidebar"
      :year="year"
      :title="title"
      is-narrow />
    <h3 v-else>{{ title }}</h3>
    <!-- the page back (narrow, VIZBI 2026 chosen): fading in as the panels do; hidden at once,
         as the panel fades in in its place (YearSidebar.vue) -->
    <Transition name="pageBack" :duration="{enter: 180, leave: 0}">
      <component
        :is="page"
        v-show="!isPanelShown"
        :key="title"
        :class="{isBelowControl: sidebar && isNarrow}" />
    </Transition>
    <template v-if="sidebar && !isNarrow" #right>
      <YearSidebar :content="sidebar" :year="year" :title="title" />
    </template>
  </ReplaceTweets>
</template>

<script setup>
import {shallowRef} from "vue";
import {useRoute} from "vue-router";
import ReplaceTweets from "@/components/ReplaceTweets.vue";
import YearSidebar from "@/components/YearSidebar/YearSidebar.vue";
import {useYearPageSidebar} from "@/composables/useYearPageSidebar";

const route = useRoute();
const year = String(route.params.year || "");
const title = `VIZBI ${year}`;
let page = shallowRef();
try {
  if (year) page = shallowRef(require(`@/assets/years/${year}/Index.vue`).default);
} catch (error) {
  console.error(`Problem with ${year}/About.vue: ${error}`);
}
// (on a phone, the top is pinned on every page of a year: Year/Index.vue, usePinnedTop.js; the
// sidebar's control with it, global.css)
// the year's sidebar content, or null (most years have none)
function getSidebar() {
  try {
    return year ? require(`@/assets/years/${year}/sidebar.json`) : null;
  } catch {
    return null;
  }
}
const {sidebar, isNarrow, isPanelShown, isSingleColumn} = useYearPageSidebar(getSidebar());
</script>

<style scoped>
/* the page below the sidebar's control (narrow): its first line's letters level with the middle
   of Highlights' dots, 24px below the control, as each panel's content (YearSidebar.vue; Seán,
   2026-10-23); the paragraph's line adds 6px above its letters */
.isBelowControl {
  padding-top: 18px;
}
.isBelowControl :deep(> p:first-child) {
  margin-top: 0;
}
.pageBack-enter-active {
  transition: opacity 0.18s ease, transform 0.18s ease;
}
.pageBack-enter-from {
  opacity: 0;
  transform: translateY(6px);
}
@media (prefers-reduced-motion: reduce) {
  .pageBack-enter-active {
    transition: none;
  }
}
:deep() img {
  /* applies to child components */
  max-width: 640px;
}
h3 span {
  font-weight: 100;
}
</style>
